import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgendaItem } from 'src/app/shared/models/app.models';

@Component({
  selector: 'app-start-meeting-dialog',
  templateUrl: './start-meeting-dialog.component.html',
  styleUrls: ['./start-meeting-dialog.component.scss']
})
export class StartMeetingDialogComponent implements OnInit {
  meetingForm: FormGroup;
  meetingTitle: string = '';
  agendaItems: AgendaItem[] = [];
  currentAgendaIndex: number = 0;
  tcDecisions: Map<number, string> = new Map();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<StartMeetingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.meetingTitle = data?.meetingTitle || '';
    this.agendaItems = data?.agendaItems || [];
    this.currentAgendaIndex = data?.currentAgendaIndex || 0;
    
    this.meetingForm = this.fb.group({
      tcDecisionEN: ['']
    });
  }

  ngOnInit(): void {
    // Load saved TC decision for current agenda item if exists
    if (this.tcDecisions.has(this.currentAgendaIndex)) {
      this.meetingForm.patchValue({ 
        tcDecisionEN: this.tcDecisions.get(this.currentAgendaIndex) 
      });
    }
  }


  get currentAgendaItem(): AgendaItem | null {
    return this.agendaItems[this.currentAgendaIndex] || null;
  }

  get hasNext(): boolean {
    return this.currentAgendaIndex < this.agendaItems.length - 1;
  }

  get hasPrevious(): boolean {
    return this.currentAgendaIndex > 0;
  }

  getAgendaStageClass(stage: any): string {
    const value = (stage || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
    if (value.includes('unsealingtechnical')) return 'stage-unseal-technical';
    if (value.includes('unsealingcommercial')) return 'stage-unseal-commercial';
    if (value.includes('unsealingcombined')) return 'stage-unseal-combined';
    if (value.includes('evaluationreview')) return 'stage-evaluation-review';
    if (value.includes('awardbid')) return 'stage-award-bid';
    return '';
  }

  selectAgendaItem(index: number): void {
    // Save current TC decision before switching
    const currentDecision = this.meetingForm.get('tcDecisionEN')?.value;
    if (currentDecision) {
      this.tcDecisions.set(this.currentAgendaIndex, currentDecision);
    }
    
    // Switch to new agenda item
    this.currentAgendaIndex = index;
    
    // Load saved TC decision for new agenda item if exists
    const savedDecision = this.tcDecisions.get(this.currentAgendaIndex) || '';
    this.meetingForm.patchValue({ tcDecisionEN: savedDecision });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  goBackToAgendaList(): void {
    // TODO: Navigate back to agenda list or close dialog
    this.dialogRef.close();
  }

  onBack(): void {
    if (this.hasPrevious) {
      this.selectAgendaItem(this.currentAgendaIndex - 1);
    }
  }

  onNext(): void {
    if (this.hasNext) {
      this.selectAgendaItem(this.currentAgendaIndex + 1);
    }
  }

  onEndMeeting(): void {
    // Save current TC decision
    const currentDecision = this.meetingForm.get('tcDecisionEN')?.value;
    if (currentDecision) {
      this.tcDecisions.set(this.currentAgendaIndex, currentDecision);
    }

    // Return all decisions
    const result = {
      agendaDecisions: Array.from(this.tcDecisions.entries()).map(([index, decision]) => ({
        agendaIndex: index,
        tcDecisionEN: decision
      }))
    };

    this.dialogRef.close(result);
  }
}
